import { Predicate } from '@ads/predicate-model';
import { FILTER_PREDICATE_NAMES, Operands } from './types';

/** *
 * @returns Predicate instance with the minimal required structure for SrAdvancedFilter
 */
export default function getDefaultEmptyPredicate(): Predicate {
    return new Predicate({
        type: 'COMPLEX',
        operator: Operands.AND,
        children: [
            new Predicate({
                name: FILTER_PREDICATE_NAMES.FILTER,
                type: 'COMPLEX',
                operator: Operands.AND,
            }),
        ],
    });
}
